import React from 'react';
import { Container } from '@plone/components';
import type { Content } from '@plone/types';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import EditalItems from '../EditalItems/EditalItems';

interface EditalViewProps {
  content: Content;
  location: string;
}

const EditalView: React.FC<EditalViewProps> = (props) => {
  const { content, location } = props;
  const path = getBaseUrl(location?.pathname || '');
  const { title, description, text } = content;

  return (
    <Container
      id="page-document"
      className={`view-wrapper edital-view blocks-group-wrapper default`}
    >
      <Container className="info" narrow>
        <Container className="cabecalho">
          <Container className="edital-info">
            <h1 className="documentFirstHeading">{title}</h1>
            <p className="description">{description}</p>
          </Container>
        </Container>
        {text && (
          <Container className="body">
            <p dangerouslySetInnerHTML={{ __html: text?.data }} />
          </Container>
        )}
      </Container>
      <EditalItems {...props} properties={content} path={path} />
    </Container>
  );
};

export default EditalView;
